export enum UserEmailDeliveryFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  BI_WEEKLY = 'bi-weekly',
  MONTHLY = 'monthly',
  UNSUBSCRIBE = 'unsubscribe'
}
